{{ status() | warehouseReleaseStatus | async }}
